import { Box } from "@mui/material";
import styled from "styled-components";

export const ContainerCheckbox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  height: 85%;
  padding: 0px 40px;
`;

export const ContainerAdmin = styled(Box)`
  width: 100%;
  display: flex;
  flex-direction: row;
`;

export const ContentCheckbox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;

  .MuiFormControlLabel-root {
    pointer-events: none;
    &:hover {
      background-color: transparent;
    }
  }
  .MuiFormControlLabel-root input[type="checkbox"] {
    pointer-events: auto;
  }

  .MuiCheckbox-root {
    &:hover {
      background-color: transparent;
    }
  }

  .MuiTouchRipple-root {
    display: none;
  }
`;
